import * as React from "react";
function SvgReddit(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect fill="currentColor" height={32} rx={6} width={32} />
      <path
        fill="#fff"
        d="M26.67 16a2.34 2.34 0 00-2.42-2.25 2.31 2.31 0 00-1.53.65 11.4 11.4 0 00-6.16-2l1-5 3.44.76a1.6 1.6 0 101.44-1.76 1.59 1.59 0 00-1.21.78l-3.92-.78a.49.49 0 00-.59.38l-1.18 5.56a11.37 11.37 0 00-6.24 2 2.34 2.34 0 10-3.21 3.41 2.66 2.66 0 00.63.42 4.09 4.09 0 000 .7c0 3.59 4.18 6.5 9.33 6.5s9.33-2.91 9.33-6.5v-.7A2.33 2.33 0 0026.67 16z"
      />
      <g fill="#ff4500">
        <path d="M20 22a6.11 6.11 0 01-4 1.23A6.14 6.14 0 0112 22a.43.43 0 01.61-.61 5.23 5.23 0 003.33 1 5.25 5.25 0 003.34-1 .47.47 0 01.64 0 .45.45 0 010 .63z" />
        <circle cx={19.68} cy={17.7} r={1.6} />
        <circle cx={12.27} cy={17.6} r={1.6} />
      </g>
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgReddit);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
